
import { defineComponent } from 'vue'
export default defineComponent({
  props: ['showOverlay', 'id'],
  setup() {
    return {}
  }
})
